export const ANIMATIONS_OFF_ATTRIBUTE_KEY = 'data-animation'
export const ANIMATIONS_OFF_ATTRIBUTE_VALUE = 'off'

export const applyIfAnimationsEnabledCss = (css: string) => `
  html:not([${ANIMATIONS_OFF_ATTRIBUTE_KEY}='${ANIMATIONS_OFF_ATTRIBUTE_VALUE}']) & {
    ${css}
  }
`
